<!-- <app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader> -->

<div class="body none">
  <!-- NAVBAR -->
  <div class="nav-home">
    <app-navbar></app-navbar>
  </div>

  <!-- MAIN start-->
  <main>
    <div class="laptop" style="overflow: hidden"></div>
    <div
      *ngIf="screen"
      class="landinghead parallax-zoom"
      style="
        background: transparent;
        width: 100vw;
        height: 100vh;
        background-size: 100vw 100vh;
        filter: brightness(0.7);
        background-position-x: center;
      "
    ></div>

    <div
      *ngIf="!screen"
      class="landinghead parallax-zoom"
      style="
        background: transparent;
        width: 100vw;
        height: 100vh;
        background-size: 100vw 100vh;
        filter: brightness(0.7);
        background-position-x: center;
      "
    ></div>

    <!-- <app-sqanimation></app-sqanimation> -->
    <app-spline></app-spline>


    <div class="logo">
      <div class="cont">
        <div class="image">
          <img
            src="https://2k21.s3.ap-south-1.amazonaws.com/gcc24logo.png"
            alt=""
          />
        </div>
      </div>
      <div class="content" style="margin-top: 3rem;">
        <div class="butbut">
          <button (click)="register()" type="button" class="btn btn-lg inverse">
            Register Now
          </button>
          <button
            [routerLink]="['/login']"
            type="button"
            class="btn btn-lg trans"
          >
            Login
          </button>
        </div>
      </div>
    </div>

    <div class="main container" style="display: none">
      <div class="content">
        <div>
          <div class="butbut">
            <button
              (click)="register()"
              type="button"
              class="btn btn-lg btn-success inverse"
            >
              Register Now
            </button>
            <button
              [routerLink]="['/login']"
              type="button"
              class="btn btn-success btn-lg trans"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid what-eureka">
      <div class="whatis">
        <h3>WHAT IS</h3>
        <h1 class="eurekaheading" #eurekaHeading>EUREKA! GCC</h1>
        <p>
          Eureka! GCC is a Business Model Competition, organized by IIT Bombay's E-Cell and powered by Gulf Islamic Investments (GII). This 5-month long competition provides a 360-degree holistic experience and offers aspiring entrepreneurs the opportunity to design solid business models, gain mentorship from renowned VCs and angel investors and avail excellent networking opportunities and educational workshops.
        </p>
      </div>
    </div>
    <section class="stats-container">
      <div class="stats-wrapper">
        <div class="stats-column">
          <div class="stats-divider" #divider></div>
          <div class="stats-box">
            <p class="stats-number" data-number="100000" #statsNumber>100,000 USD</p>
            <p class="stats-text">Prize Money</p>
          </div>
          <div class="stats-divider" #divider></div>
          <!-- <div class="stats-box">
            <p class="stats-number" data-number="300" #statsNumber>300+</p>
            <p class="stats-text">Mentors</p>
          </div> -->
        </div>
        <div class="stats-column">
          <div class="stats-divider" #divider></div>

          <div class="stats-box">
            <p class="stats-number" data-number="600" #statsNumber>600+</p>
            <p class="stats-text">Startups</p>
          </div>
          <div class="stats-divider" #divider></div>
          <!-- <div class="stats-box">
            <p class="stats-number" data-number="27" #statsNumber>27th</p>
            <p class="stats-text">Edition</p>
          </div> -->
        </div>
        <div class="stats-column">
          <div class="stats-divider" #divider></div>

          <div class="stats-box">
            <p class="stats-number" data-number="50" #statsNumber>50+</p>
            <p class="stats-text">Mentors</p>
          </div>
          <div class="stats-divider" #divider></div>
          <!-- <div class="stats-box">
            <p class="stats-number" data-number="7" #statsNumber>7</p>
            <p class="stats-text">Tracks</p>
          </div> -->
        </div>
      </div>
    </section>
  </main>
  <!-- MAIN END -->
  <div class="aftermov">
    <div class="container">
    <iframe src="https://www.youtube-nocookie.com/embed/o0giJNUJcdM?si=Wnog4S3Yok5v6psw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div>
  <!-- WHAT IS EUREKA START -->
  <div
    class="boxy"
    style="
      padding-bottom: 40px;
      margin-top: 5rem;
      background: #fbfcfc;
      background-size: contain;
    "
  >
    <div>
      <div class="container-fluid why"></div>
    </div>
    <div class="container-fluid vision">
      <div class="whyureka">
        <h3>WHY</h3>
        <h1 class="eurekaheading" #eurekaHeading>EUREKA! GCC</h1>
      </div>
      <div class="benefitcards">
        <app-eurekacards></app-eurekacards>
      </div>
    <!-- </div> -->
    <!-- <div class="structure">
      <div class="struct-heading">
        <h1>STRUCTURE</h1>
        <p></p>
      </div> -->

      <!-- new structure -->

      <!-- <div class="struc-card-container">
            <div class="struc-card-content">
                <div class="card"  #card>
                    <p class="card__date">27TH AUG - 17TH OCT</p>
                    <span class="card__title">The countdown begins</span>
                    <p class="card__subtitle">Eureka! is opening its doors for applications starting from August 27th until October 17th. To apply, all you need to do is fill out a questionnaire with essential details about yourself and your startup idea. Once you've submitted your application, the anticipation begins as we carefully review each submission, selecting the top startups for next round.</p>
                </div>
            <div class="card"  #card>
                <p class="card__date">27TH AUG - 17TH OCT</p>
                <span class="card__title">The countdown begins</span>
                <p class="card__subtitle">Eureka! is opening its doors for applications starting from August 27th until October 17th. To apply, all you need to do is fill out a questionnaire with essential details about yourself and your startup idea. Once you've submitted your application, the anticipation begins as we carefully review each submission, selecting the top startups for next round.</p>
            </div>
            <div class="card"  #card>
                <p class="card__date">27TH AUG - 17TH OCT</p>
                <span class="card__title">The countdown begins</span>
                <p class="card__subtitle">Eureka! is opening its doors for applications starting from August 27th until October 17th. To apply, all you need to do is fill out a questionnaire with essential details about yourself and your startup idea. Once you've submitted your application, the anticipation begins as we carefully review each submission, selecting the top startups for next round.</p>
            </div>
            <div class="card"  #card>
                <p class="card__date">27TH AUG - 17TH OCT</p>
                <span class="card__title">The countdown begins</span>
                <p class="card__subtitle">Eureka! is opening its doors for applications starting from August 27th until October 17th. To apply, all you need to do is fill out a questionnaire with essential details about yourself and your startup idea. Once you've submitted your application, the anticipation begins as we carefully review each submission, selecting the top startups for next round.</p>
            </div>


            </div>
        </div> -->

      <!-- new timeline -->
      <!-- <div class="newtimeline">
        <app-newtimeline *ngIf="screen"></app-newtimeline>
        <app-structure *ngIf="!screen"></app-structure>
      </div>
    </div> -->

    <!-- <div id="style"></div>
  </div>
  <div class="zonals">
    <h1>GALLERY</h1>
    <app-zonals></app-zonals>
    <div class="gallery-bott-space"></div>
  </div> -->

  <!-- <div class="testimonial">
    <h1 style="margin-bottom: 3rem">TESTIMONIALS</h1>
    <app-landtesti style="position: relative"></app-landtesti>
  </div> -->
  <div class="boxy" style="padding-bottom: 40px">
    <app-footer></app-footer>
  </div>
<!-- </div> -->
